import { render, staticRenderFns } from "./SlimSelect.vue?vue&type=template&id=80a0041c&"
import script from "./SlimSelect.vue?vue&type=script&lang=js&"
export * from "./SlimSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports